import { motion } from 'framer-motion';
import { ChevronRight, Headphones, LayoutDashboard, LogOut, ReceiptText, ShieldCheck, UserRound, WalletCards } from 'lucide-react';
import type { CSSProperties } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { post } from '../api';
import { money } from '../format';
import { useAuth } from '../App';
import Brand from './Brand';

const nav = [
  { to: '/dashboard', label: 'Главная', icon: LayoutDashboard },
  { to: '/services', label: 'Услуги', icon: Headphones },
  { to: '/orders', label: 'Заказы', icon: ReceiptText },
  { to: '/wallet', label: 'Баланс', icon: WalletCards }
];

const accountNav = { to: '/profile', label: 'Профиль', icon: UserRound };

function SideLink({ to, label, icon: Icon }: { to: string; label: string; icon: typeof LayoutDashboard }) {
  return <NavLink to={to}>{({ isActive }) => <>
    {isActive && <motion.i className="side-active-bg" layoutId="side-active" transition={{ type: 'spring', stiffness: 420, damping: 38 }} />}
    <span className="side-nav-icon"><Icon size={18} /></span>
    <span className="side-nav-text">{label}</span>
    <ChevronRight className="side-nav-arrow" size={15} />
    {isActive && <motion.b className="side-active-line" layoutId="side-active-line" />}
  </>}</NavLink>;
}

export default function Layout() {
  const { user, setUser } = useAuth();
  const navigate = useNavigate();
  const navItems = user?.is_admin ? [...nav, accountNav, { to: '/admin', label: 'Админ панель', icon: ShieldCheck }] : [...nav, accountNav];
  const logout = async () => {
    await post('/auth/logout');
    setUser(null);
    navigate('/login');
  };
  return (
    <div className="app-shell">
      <aside className="sidebar">
        <div className="sidebar-brand"><Brand /><span>Личный кабинет</span></div>
        <nav className="side-nav">
          <div className="side-nav-group">
            <span className="side-nav-label">Навигация</span>
            {nav.map((item) => <SideLink key={item.to} {...item} />)}
          </div>
          <div className="side-nav-group">
            <span className="side-nav-label">Аккаунт</span>
            <SideLink {...accountNav} />
          </div>
          {user?.is_admin && <div className="side-nav-group side-admin-group">
            <span className="side-nav-label">Управление</span>
            <SideLink to="/admin" label="Админ панель" icon={ShieldCheck} />
          </div>}
        </nav>
        <div className="sidebar-account">
          <div className="sidebar-avatar-wrap"><div className="avatar">{user?.name.slice(0, 1).toUpperCase()}</div><i /></div>
          <div><b>{user?.name}</b><span>Баланс · <strong>{money(user?.balance || 0)}</strong></span></div>
          <button onClick={logout} aria-label="Выйти" title="Выйти"><LogOut size={19} /></button>
        </div>
      </aside>
      <main className="main-content"><Outlet /></main>
      <nav className="bottom-nav" style={{ '--nav-count': navItems.length } as CSSProperties}>
        {navItems.map(({ to, label, icon: Icon }) => (
          <NavLink key={to} to={to}>{({ isActive }) => <><Icon size={21} /><span>{label}</span>{isActive && <motion.i layoutId="bottom-active" />}</>}</NavLink>
        ))}
      </nav>
    </div>
  );
}
